import { render, staticRenderFns } from "./SimpleDropdownConfiguration.vue?vue&type=template&id=8eaf918c&scoped=true&"
import script from "./SimpleDropdownConfiguration.vue?vue&type=script&lang=js&"
export * from "./SimpleDropdownConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./SimpleDropdownConfiguration.vue?vue&type=style&index=0&id=8eaf918c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eaf918c",
  null
  
)

export default component.exports